import MobileCard from "../mobile-card";
import styles from "./index.module.scss";
import MobileOfferCard from "../mobile-offer-card";
import React from "react";
import { StatusObjectColorFilter } from "../../../utils/utils";
// import NoDataFound from '../no-data-found';

export default function MobileCardListing({
  innerRef,
  type,
  recentPropertyData,
  refetch,
  loginType
}: any) {
  return (
    <div className={styles.listingWrap}>
      {
        recentPropertyData?.pages[0]?.length > 0 && (
          <>
            {recentPropertyData?.pages?.map((properties: any, idx: number) =>
              type !== "bid" ? (
                <React.Fragment key={idx}>
                  {properties?.map((item: any, idx: number) => (
                    <React.Fragment key={item.id}>
                      <MobileCard
                        loginType={loginType}
                        item={item}
                        innerRef={innerRef}
                        status={StatusObjectColorFilter(item?.status)}
                        refetch={refetch}
                        isSavedProperty={type === "saved"}
                      />
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {properties?.map((item: any, idx: number) => (
                    <React.Fragment key={item.id}>
                      <MobileOfferCard
                        loginType={loginType}
                        item={item}
                        status={StatusObjectColorFilter(item?.status)}
                        refetch={refetch}
                      />
                    </React.Fragment>
                  ))}
                </React.Fragment>
              )
            )}
          </>
        )
        //  : (
        //   <NoDataFound panelIndex={0} properties={true} />
        // )
      }
    </div>
  );
}
